import KaboodleModal from "./KaboodleModal";
import Card from "components/Card/Card";

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  errors?: string[];
  message?: string;
}

const ErrorModal = ({
  isOpen,
  onClose,
  message = "Error",
  errors = [],
}: ErrorModalProps) => {
  return (
    <KaboodleModal isOpen={isOpen} onClose={onClose}>
      <Card heading={message}>
        {errors.map((error, index) => (
          <p key={index}>{error}</p>
        ))}
      </Card>
    </KaboodleModal>
  );
};

export default ErrorModal;
